// extracted by mini-css-extract-plugin
export default {"container":"GR-z","darkBackground":"HR-z","whiteBackground":"IR-z","headerButton":"JR-z","calloutHeading":"KR-z","calloutSubHeading":"LR-z"};